import Router, {Routes} from 'universal-router';
import generateUrls from 'universal-router/generateUrls';

export interface ConfiguredRouter<Result, Deps extends Record<string, any>> {
	router: Router<Result, Deps>;
	urlGenerator: ReturnType<typeof generateUrls>;
}

export function createRouter<Result, Deps extends Record<string, any>>(
	routes: Routes<Result, Deps>,
	deps?: Deps,
	options?: {onError?(error: unknown): void},
): ConfiguredRouter<Result, Deps> {
	const router = new Router<Result, Deps>(routes, {
		context: deps,
		errorHandler: options?.onError
			? error => {
					options!.onError!(error);
					throw error;
				}
			: undefined,
	});

	const urlGenerator = generateUrls(router as Router);

	return {router, urlGenerator};
}
